export const sameEquivalent = (a, b) => a?.id === b?.id && a?.type === b?.type;

/** Remove um vínculo da lista (puro — usado na exclusão e nos testes). */
export function withoutEquivalentLink(equivalentIds = [], deletedLink) {
  if (!deletedLink?.id || !deletedLink?.type) return [...(equivalentIds || [])];
  return (equivalentIds || []).filter((eq) => !sameEquivalent(eq, deletedLink));
}
